<template>
  <div class="big-screen-container" :style="containerStyle">
    <div class="back-btn" @click="goBack">
      <svg class="back-icon" width="22" height="22" viewBox="0 0 22 22" style="vertical-align: middle;">
        <circle cx="11" cy="11" r="10" fill="none" stroke="#1B77FF" stroke-width="2" />
        <polyline points="12,7 8,11 12,15" fill="none" stroke="#1B77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="back-text">返回上一页</span>
    </div>
    <div class="big-screen-footer"></div>
    <div class="background-image">
      <img src="../assets/images/Group_42157.png" class="bg-img" />
      <object type="image/svg+xml" :data="require('@/assets/svg/go-to.svg')" class="overlay-img" @load="onSvgLoad"></object>
    </div>
    <div class="big-screen-header"></div>
    <div class="big-screen-content">
      <div class="industry-map-container">
        <img src="../assets/images/fuzhuang1.png" class="hover-zoom" style="width: 234px; height: 251px;margin-left: 112px;" @click="goToTupu('纺织服装')" />
        <img src="../assets/images/qingjienengyuan.png" class="hover-zoom" style="width: 234px; height: 251px;margin-right: 112px;" @click="goToTupu('清洁能源')" />
      </div>
      <div class="industry-map-container2">
        <img src="../assets/images/qimopei.png" class="hover-zoom" style="width: 234px; height: 251px;margin-left: 362px;" @click="goToTupu('汽模配')" />
        <img src="../assets/images/gongnengcailiao.png" class="hover-zoom" style="width: 234px; height: 251px;margin-left: 112px;" @click="goToTupu('功能材料')" />
        <img src="../assets/images/linggangzhuangbei.png" class="hover-zoom" style="width: 234px; height: 251px;margin-right: 362px;" @click="goToTupu('临港装备')" />
      </div>
    </div>
   
  </div>
</template>

<script>
import { talentApi } from '../api/talent'
import autofit from 'autofit.js'

export default {
  name: 'IndustryMap',
  data() {
    return {
      subIndexList:[]
    }
  },
  mounted() {
    autofit.init({
      fast: true,
      width: 1920,
      height: 1080,
      renderDom:'#app',
    },true)
    this.getSubIndexList()
  },
  methods: {
    goToTupu(name) {
      this.$router.push({ path: '/zhongdian-tupu', query: { id: this.subIndexList.find(item => item.configName === name).indexId, name: name } })
    },
    getSubIndexList() {
      talentApi.subIndexListByParentId(this.$route.query.id).then(res => {
        this.subIndexList = res
        console.log(this.subIndexList)
      })
    },
    goBack() {
      this.$router ? this.$router.back() : window.history.back();
    }
  }
}
</script>

<style scoped>
.big-screen-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #0f1624;
  color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-image: url('../assets/images/zhongdian1.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.big-screen-content {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* 头部和底部高度 */
  min-height: 0;
  cursor: pointer;
}
.industry-map-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 200px;
}
.industry-map-container2 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.industry-map-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.industry-circle-container {
  position: relative;
  width: 1850px;
  height: 700px;
  margin: 0 auto;
  margin-top: 40px;
}
.industry-map-img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 380px;
  height: 380px;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.industry-icon {
  position: absolute;
  width: 180px;
  height: 180px;
  z-index: 3;
}
.industry-icon-1 { /* 左上 */
}
.industry-icon-2 { /* 左下 */
  left: 13%;
  bottom: 7%;
}
.industry-icon-3 { /* 下中 */
  left: 50%;
  bottom: -2%;
  transform: translateX(-50%);
}
.industry-icon-4 { /* 右下 */
  right: 13%;
  bottom: 7%;
}
.industry-icon-5 { /* 右上 */
  right: 2%;
  top: 8%;
}
.big-screen-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-image: url('../assets/images/icon_zhongdian.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70px;
}
.big-screen-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-image: url('../assets/images/big-screen-footer.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70px;
}
.back-btn {
  position: absolute;
  top: 80px;
  left: 70px;
  display: flex;
  align-items: center;
  color: #1B77FF;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  z-index: 20;
  user-select: none;
  transition: color 0.2s;
}
.back-btn:hover {
  color: #409eff;
}
.back-icon {
  margin-right: 6px;
  display: inline-block;
}
.back-text {
  font-family: Alibaba PuHuiTi 2.0;
  font-size: 16px;
  font-weight: 250;
  line-height: normal;
  letter-spacing: 0em;
  color: #1B77FF;
}
.background-image {
  position: relative;
  width: 100%;
  height: 100%;
}
.overlay-img {
  position: absolute;
  left: 50%;
  top: 38%;
  transform: translate(-50%, -50%);
}
.bg-img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.overlay-img {
  z-index: 2;
}

.hover-zoom {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.hover-zoom:hover {
  transform: scale(1.1);
  z-index: 20;
}
</style> 